import { _HTMLElement } from './utils';

export const withFormValidation = (Base = _HTMLElement) =>
  class extends Base {
    _validators = [];

    connectedCallback() {
      super.connectedCallback && super.connectedCallback();

      if (!this._input) {
        throw new Error(
          '[withFormValidation] `_input` property is not defined in the constructor'
        );
      }

      this.setAttribute('aria-invalid', !this.validity.valid);
    }

    checkValidity() {
      this._input.checkValidity();

      // Clear any existing custom errors before running validation.
      this.setCustomValidity('');
      this._validators.every(fn => fn(this));

      const valid = this.validity.valid;
      this.classList.add('upd-validated');
      this.setAttribute('aria-invalid', !valid);

      this.dispatchEvent(
        new CustomEvent('updvalidation', {
          bubbles: true,
          composed: true,
        })
      );
      // TODO: revisit this flag as it is only needed for upd-input
      // https://app.clubhouse.io/updater/story/11465/
      this._hasBeenValidatedAlready = true;
      return valid;
    }

    setCustomValidity(message) {
      this._input.setCustomValidity(message);
    }

    addValidator(validatorFn) {
      this._validators.push(validatorFn);
    }

    removeValidator(validatorFn) {
      this._validators = this._validators.filter(fn => fn !== validatorFn);
    }

    set validators(validators) {
      this._validators = this._validators.concat(validators);
    }

    get validity() {
      return this._input.validity;
    }

    get validationMessage() {
      return this._input.validationMessage;
    }

    get willValidate() {
      return this._input.willValidate;
    }
  };
